import * as React from "react";
import './File.css';

function File({
                  label,
                  onChange,
                  accept,
                  multiple = false,
                  required = false,
                  name,
                  disabled = false,
                  className = ""
              }) {
    const handleChange = (e) => {
        const files = e.target.files || [];
        const value = multiple ? Array.from(files) : (files[0] || null);
        onChange?.(value);
    };

    return (
        <label className={`FormFile ${className}`}>
            {label}
            <input
                type="file"
                name={name}
                accept={accept}
                required={required}
                multiple={multiple}
                onChange={handleChange}
                disabled={disabled}
            />
        </label>
    );
}

export default File;
